var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import styled from "styled-components";
import { Dropdown } from "react-bootstrap";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import { greys } from "@irati/ui/src/global/colors";
import { IconButton } from "@irati/ui/src/Button";
import wasCreatedBy from "@irati/recognition/utils/wasCreatedBy";
var Toggle = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), greys.medium);
var MenuActions = /** @class */ (function (_super) {
    __extends(MenuActions, _super);
    function MenuActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuActions.prototype.render = function () {
        var _a = this.props, item = _a.item, children = _a.children, props = __rest(_a, ["item", "children"]);
        var user = authentication.user();
        var isAdmin = authentication.isGlobalAdmin();
        var isUserContent = !item ? false : wasCreatedBy(item, user);
        var canDeletePoll = !!authentication.apps("recognition.poll.delete");
        var entries = children({
            item: item,
            isUserContent: isUserContent,
            canDeletePoll: canDeletePoll,
            isAdmin: isAdmin
        });
        if (!Array.isArray(entries)) {
            entries = [entries];
        }
        entries = entries.filter(function (entry) { return entry; });
        var isHidden = entries.length === 0;
        if (isHidden) {
            return null;
        }
        return (React.createElement(Dropdown, __assign({}, props, { id: id("button", this.props) }),
            React.createElement(Toggle, { icon: "ellipsis", bsRole: "toggle" }),
            React.createElement(Dropdown.Menu, null, entries)));
    };
    MenuActions.defaultProps = {
        id: "menu-actions"
    };
    return MenuActions;
}(Component));
export default MenuActions;
var templateObject_1;
